import { Component } from '@angular/core'
import { FieldBlueprint, NEW_JOINEE_FORM11_PDF_FIELDS_BLUEPRINT } from 'src/app/constants/config-blueprint'

@Component({
  selector: 'app-form11-pdf-screen-config',
  template: `<app-shared-wf-screen-config
    [SCREEN_TYPE]="SCREEN_TYPE"
    [steps]="steps"
    [massAction]="false"></app-shared-wf-screen-config>`
})
export class Form11PdfScreenConfigComponent {
  readonly SCREEN_TYPE = 'FORM_11_PDF_CONFIG'
  steps: { title: string; blueprint: FieldBlueprint[] }[] = [
    { title: 'Form 11 PDF Fields', blueprint: NEW_JOINEE_FORM11_PDF_FIELDS_BLUEPRINT }
  ]
}
